import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gridnav-item',
  templateUrl: './gridnav-item.component.html',
  styleUrls: ['./gridnav-item.component.css']
})
export class GridnavItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
